/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2023 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import {
    ApiParameter,
    get,
    ServiceResult,
} from "@insite/client-framework/Services/ApiService";

const requestSystemListUrl = "api/custom/systemList/GetSystemListValues?systemListName";

export interface RequestSystemListModel {
    additionalInfo: string;
    description: string;
    name: string;
    systemListId: string;
}

export interface RequestSystemListParameterModel {
    slug: string;
}



export interface RequestSystemListApiParameter extends ApiParameter {
    url: Partial<RequestSystemListParameterModel>;
}

export async function requestSystemList(parameter: RequestSystemListApiParameter): Promise<ServiceResult<RequestSystemListModel[]>> {
    try {

        const requestSystemListModel = await get<RequestSystemListModel[]>(`${requestSystemListUrl}=${parameter.url.slug}`);
        return {
            result: requestSystemListModel,
            successful: true,
        };
    } catch (error) {
        return {
            successful: false,
            errorMessage: ((error as any)?.errorJson?.message),
        };
    }
}